import { createSelector } from 'reselect';

import { getSiteUrl, getCompId } from 'shared/selectors/app-settings';
import parseQueryParams from 'shared/utils/get-query-params';

import { URL_PARAM_COMP_ID, URL_PARAM_VIDEO_ID } from '@wix/wix-vod-shared/src/common/constants/url';

const getQueryParams = createSelector([getSiteUrl], parseQueryParams);

export const isCurrentComponentIdInUrl = createSelector(
  [getQueryParams, getCompId],
  (queryParams, compId) => Boolean(compId && queryParams[URL_PARAM_COMP_ID] === compId)
);

export const getVideoIdFromUrl = createSelector(
  [getQueryParams, isCurrentComponentIdInUrl],
  (queryParams, isCompIdInUrl) => (isCompIdInUrl ? queryParams[URL_PARAM_VIDEO_ID] : null)
);

export const getUrlParam = createSelector(
  [
    getQueryParams,
    isCurrentComponentIdInUrl,
    (state, key) => key,
  ],
  (queryParams, isCompIdInUrl, key) => (isCompIdInUrl ? queryParams[key] : null));



// WEBPACK FOOTER //
// ./src/widget/selectors/query-params.js